import { render, staticRenderFns } from "./DeduplicateItem.vue?vue&type=template&id=371d8647&scoped=true"
import script from "./DeduplicateItem.vue?vue&type=script&lang=js"
export * from "./DeduplicateItem.vue?vue&type=script&lang=js"
import style0 from "./DeduplicateItem.vue?vue&type=style&index=0&id=371d8647&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371d8647",
  null
  
)

export default component.exports